import { User } from "@saleor/fragments/types/User";
import { createContext, useContext } from "react";

interface RecentUser {
  email: string;
  firstName: string;
  lastName: string;
}

export interface Account {
  firstName: string;
  lastName: string;
  email: string;
  token: string;
  csrf: string;
  lastLogin: number;
}

interface SavedAccountContextProps {
  savedAccounts: Account[];
  ignoredAccounts: string[];
  removeAccount: string;
  recentUser: RecentUser;
  setUser: (user: User) => void;
  setRecentUser: (user: RecentUser) => void;
  logSavedAccount: (user: any, token: string, csrfToken: string) => void;
  handleAddSavedAccount: (account: Account) => void;
  handleRemoveFromIgnoredAccounts: (email: string) => void;
  handleUpdateSavedAccount: (email: string, data: any) => void;
  setIgnoredAccounts: (accountEmails: string[]) => void;
  setRemoveAccount: (email: string) => void;
  setShowSaveAccountDialog: (state: boolean) => void;
  showSaveAccountDialog: boolean;
  handleRemoveAccount: () => void;
}

const SavedAccountContext = createContext<SavedAccountContextProps>({
  handleAddSavedAccount: () => undefined,
  handleRemoveAccount: () => undefined,
  handleRemoveFromIgnoredAccounts: () => undefined,
  handleUpdateSavedAccount: () => undefined,
  ignoredAccounts: undefined,
  logSavedAccount: () => undefined,
  recentUser: undefined,
  removeAccount: undefined,
  savedAccounts: undefined,
  setIgnoredAccounts: () => undefined,
  setRecentUser: () => undefined,
  setRemoveAccount: () => undefined,
  setShowSaveAccountDialog: () => undefined,
  setUser: () => undefined,
  showSaveAccountDialog: undefined
});

export const useSavedAccount = () => useContext(SavedAccountContext);

export default SavedAccountContext;
